import buildIconHeaderTemplate from '@/grid/buildIconHeaderTemplate'
import i18n from '@/lang/i18n'
import { ConfigurationTargetResponseTimeConfigurationResponse } from '@/modules/configurationModule/detail/local-samples/target-response-times/services/target-response-types.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { targetResponseTimesConfigurationServices } from '@/modules/configurationModule/detail/local-samples/target-response-times/services/target-response-types.service'
import { store } from '@/store/store'

export const columnsDefTextTargetResponseTimesTypesGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            field: 'sampleType.description',
            minWidth: 200,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.topographicCode'),
            field: 'topographicCode.description',
            minWidth: 200,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            field: 'procedure.description',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            field: 'mostLikelyMorphologicCode.description',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.priorities'),
            colId: 'priority',
            field: 'priority.name',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.department'),
            colId: 'department',
            field: 'department.name',
            minWidth: 200,
            flex: 1,
            suppressSizeToFit: true,
            filter: false,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.daysToGlobalTargetResponseTime'),
            headerTooltip: i18n.tc('configuration.grid.daysToGlobalTargetResponseTime'),
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-globe')
            },
            field: 'daysToGlobalTargetResponseDate',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.daysToDiagnosisTargetResponseTime'),
            headerTooltip: i18n.tc('configuration.grid.daysToDiagnosisTargetResponseTime'),
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-file-chart-line')
            },
            field: 'daysToDiagnosticTargetResponseDate',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.daysToGrossingTargetResponseTime'),
            headerTooltip: i18n.tc('configuration.grid.daysToGrossingTargetResponseTime'),
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-scalpel-path')
            },
            field: 'daysToSampleGrossingDelay',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.daysToRegistryTargetResponseTime'),
            headerTooltip: i18n.tc('configuration.grid.daysToRegistryTargetResponseTime'),
            headerComponentParams: {
                template: buildIconHeaderTemplate('far fa-cabinet-filing')
            },
            field: 'daysToRegisterTargetResponseDate',
            minWidth: 80,
            flex: 1,
            suppressSizeToFit: true
        }
    ]

export interface TargetResponseTimesTypesGridState extends CrudModelPaginatorLaboratory<ConfigurationTargetResponseTimeConfigurationResponse> {
    labId: number
}
export const initialTargetResponseTimesTypesGridState =
    (): TargetResponseTimesTypesGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.localSamples.targetResponseTimes',
        columnsDef: columnsDefTextTargetResponseTimesTypesGrid(),
        datasource: new PaginatorLaboratoryDatasource(targetResponseTimesConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
